import app from '../app.first';
import { each } from 'lodash';

app.IndustryBreakdown = class extends app.Component {
	constructor($this) {
        super($this);

		app.ajax('/recruiter/search/search-results-by-industry.json' + window.location.search, null, false)
			.then(r => {
				if (r && r.countData) {
					each(r.countData, (industry, i) => {
						let $card = this.$el.find('.count-card').eq(i);

						if (!$card.length) {
							return;
						}

						$card.find('.count-number').removeClass('hide').text(industry.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
						$card.find('.count-name').removeClass('hide').text(industry.title).trigger('classChange');
						$card.find('img').remove();

						if (industry.title.toLowerCase() != 'total') {
							$card.css('cursor', 'pointer');

							/**
							 * [MCM-59]
							 * Add click event to search counters
							 * This click event redirect the search
							 * with 'experience_industry_ids[]={industry.id}'
							 * on URL query string
							 */
							const evtHandler = (evt) => {
								let pageHref = window.location.href,
									queryString = /\?/.test(pageHref) ? '&' : '?';

								window.location.href = `${pageHref}${queryString}experience_industry_ids[]=${industry.id}`;
							};
							
							$card.on('click', evtHandler);
						}
					});
				}

				if (r && r.baselineCount) {
					Object.keys(r.baselineCount).forEach((key, index) => {
						let baseline = r.baselineCount[key];
						let $card = this.$el.find('.count-card').eq(index + 6); // Adjust as needed
				
						if (!$card.length) {
							return;
						}
				
						// Update card content
						$card.find('.count-number').removeClass('hide').text(baseline.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
						$card.find('.count-name').removeClass('hide').text('matches for ' + baseline.title).trigger('classChange');
						$card.find('img').remove();
				
						// Find the table within the $card and update its rows
						let $tableRows = $card.find('table tr');
				
						$tableRows.each(function(rowIndex) {
							if (rowIndex === 0) return; // Skip the header row
				
							const $row = $(this);
							const scoreCell = $row.find('td:first-child');
							const countCell = $row.find('td:last-child');
				
							// Default count is 0 if the score is not found
							let countFound = 0;
				
							// Check if the score exists in the current baseline entry
							if (baseline[scoreCell.text()]) {
								countFound = baseline[scoreCell.text()].count;
							}
				
							// Update the count in the table cell
							countCell.text(countFound);
						});

						$card.css('cursor', 'pointer');

						const evtHandler = (evt) => {
							const $table = $card.find('table');
							$table.toggleClass('hidden');
						};
						
						$card.on('click', evtHandler);
					});
				}
				

				this.$el.find('.count-card img').parents('.cell').remove();
			});
	}
}